import bus from './bus'
export default function(dsBridge) {
  dsBridge.register('refreshPage', () => {
    bus.$root.$emit('refreshPage')
  })
  dsBridge.register('socket', evt => {
    bus.$root.$emit('socket', evt)
  })
}



// WEBPACK FOOTER //
// ./src/lib/app2H5.js